<template>
  <section class="page__slide site-landing padded">
    <section
      class="d-landing-vis"
      ref="js-landing-generative"
      id="js-landing-vis"
    ></section>
    <transition name="fade">
      <section class="site-landing__text text_align_center">
        <p>
          Welcome to my personal space on the web with no agenda (read:
          <b>NOT</b> a portfolio).
        </p>
        <p>
          This is my little corner to document all the different curiosities and
          hobbies I explore.
        </p>
      </section>
    </transition>
  </section>
</template>

<script>
import P5 from 'p5'
export default {
  data() {
    return {
      dim: '',
      p5: null
    }
  },
  methods: {
    getSize: function() {
      this.dim = {
        width:
          this.$refs['js-landing-generative'].parentElement.clientWidth * 0.9,
        height:
          this.$refs['js-landing-generative'].parentElement.clientHeight / 2
      }
    },
    createCanvas: function() {
      let size = this.dim

      let id = this.$refs['js-landing-generative'].id

      let sketch = s => {
        let bg = '#f8f8f8',
          color = '#1d1d1d',
          particlesNumber = 40,
          maxRad = 20,
          dots = [],
          positions = []

        s.setup = function() {
          let canvas = s.createCanvas(size.width, size.height)
          for (let i = 0; i < particlesNumber; i++) {
            dots[i] = new Dot(s)
          }
          s.frameRate(10)
        }
        s.windowResized = () => {
          this.getSize()
          let size = this.dim
          s.resizeCanvas(size.width, size.height)
        }
        s.draw = function() {
          s.background(bg)

          for (let i = 0; i < particlesNumber; i++) {
            dots[i].move(s)
            positions[i] = dots[i].getPos()
            dots[i].display(s)
          }

          positions.forEach(p => {
            if (s.dist(p.x, p.y, s.mouseX, s.mouseY) < s.width / 10) {
              s.push()
              s.stroke(color)
              let mouse = s.createVector(s.mouseX, s.mouseY)
              let pos = mouse.lerp(p, 0.8)
              s.line(s.mouseX, s.mouseY, pos.x, pos.y)
              s.pop()
            }
          })
        }
        class Dot {
          constructor(s) {
            this.amount = s.random()
            this.init = s.createVector(
              s.random(maxRad, s.width - maxRad * 2),
              s.random(maxRad, s.height - maxRad * 2)
            )
            this.target = s.createVector(
              s.random(maxRad, s.width - maxRad * 2),
              s.random(maxRad, s.height - maxRad * 2)
            )
            this.lerped = this.init
            this.curRad

            this.sw = 1

            let ran = s.random(1)
            if (ran < 0.25) {
              this.sc = color
            } else if (ran < 0.66) {
              this.sc = color
              this.sw = 3
            } else {
              this.f = color
            }
          }

          newPos(s) {
            this.init = s.createVector(
              s.random(maxRad, s.width - maxRad * 2),
              s.random(maxRad, s.height - maxRad * 2)
            )

            this.target = s.createVector(
              s.random(maxRad, s.width - maxRad * 2),
              s.random(maxRad, s.height - maxRad * 2)
            )
          }
          move(s) {
            if (this.amount >= 1) {
              this.newPos(s)
              this.amount = 0
            }

            this.lerped.lerp(this.target, this.amount)
            this.curRad = s.lerp(maxRad, 0, this.amount * 2)
            this.amount += 0.01
          }
          getPos() {
            return this.lerped
          }
          display(s) {
            s.noFill()
            s.noStroke()

            s.push()
            if (this.f) {
              s.fill(this.f)
            }
            if (this.sc) {
              s.stroke(this.sc)
              s.strokeWeight(this.sw)
            }

            s.ellipse(this.lerped.x, this.lerped.y, this.curRad, this.curRad)
            s.pop()
          }
        }
      }
      this.p5 = new P5(sketch, id)
    }
  },

  mounted: function() {
    this.getSize()
    this.createCanvas()
  }
}
</script>

<style scoped>
.site-landing {
  display: flex;
  flex-direction: column;
}
.d-landing-vis {
  height: 50vh;
  align-self: center;
}
.site-landing__text {
  width: 100%;
  padding: var(--padding-lg);
}
</style>
